import {getCountriesValues} from "../../Middleware/fetch";

const getVariablesValues = async (top3, requestVariables) => {
	// Get variables values from the API
	const requestValues = {...requestVariables, paises: [...top3, "Colombia"]};
	const countriesValues = await getCountriesValues(requestValues);

	// Build countries variables list
	const variablesValues = {Colombia: []};
	top3.forEach((country) => {
		variablesValues[country] = [];
	});

	const axisIDs = ["demanda", "idioma", "est_mercados", "ecommerce", "acceso"];

	axisIDs.forEach((axis) => {
		const axisVariables = Object.keys(countriesValues[axis]);

		axisVariables.forEach((variable) => {
			const variablesByCountry = Object.keys(countriesValues[axis][variable]);

			variablesByCountry.forEach((country) => {
				variablesValues[country][variable] = countriesValues[axis][variable][country];
			});
		});
	});

	return variablesValues;
};

export default getVariablesValues;
